import instance, { PPR_API_URL } from 'api';
import { ITask } from './interfaces';

export const loadTaskPpr = (taskId: number): Promise<ITask> => {
  return instance(true, PPR_API_URL)
    .get(`task/load/` + taskId)
    .then((response) => response.data);
};
